<template>
  <CategoryLayout
    type="genre"
    :category-info="genre"
    :label="label"
    :searcher="customSearcher"
    :show-categories="true"
    :show-nav-bar="showNavBar"
    :show-genres="false"
    show-extra
    :sort-strategy="sortStrategy"
    :publications="authorBooks"
    :custom-back-to="toPrevRouteLink"
    :custom-counter="customCounter"
    @change="filterChanged"
  />
</template>

<script>
import { mapGetters } from 'vuex';

import SearchPublicationsFactory from '@/classes/factories/SearchPublicationsFactory';

import SessionStorageService from '@/services/SessionStorageService';

import libraryViewScrollMixin from '@/components/mixins/libraryViewScrollMixin';

import CategoryLayout from '@/components/views/CategoryView/CategoryLayout.vue';

export default {
  name: 'GenreView',
  components: {
    CategoryLayout
  },
  mixins: [libraryViewScrollMixin],
  props: {
    genre: Object,
    publications: Array,
    searcher: Object,
    sortStrategy: String,
    customCounter: [Number, String]
  },
  data() {
    return {
      customSearcher: this.searcher
    };
  },
  computed: {
    ...mapGetters('LibraryStore', ['searchPublications']),
    toPrevRouteLink() {
      const prevRoute = this.$store.state.ContextStore.previousNotGenreRoute;
      const storedPrevRoute = SessionStorageService.get('previousRoute');

      let actualPrevRoute;
      if (prevRoute?.name) {
        actualPrevRoute = prevRoute;
      } else if (storedPrevRoute?.name) {
        actualPrevRoute = storedPrevRoute;
      }
      return actualPrevRoute;
    },
    label() {
      return this.genre?.name ?? '';
    },
    authorBooks() {
      if (!this.customSearcher && !this.publications) {
        return [];
      }
      if (this.publications && this.searcher === this.customSearcher) {
        return this.publications;
      }
      return this.searchPublications(this.customSearcher);
    },
    showNavBar() {
      return this.genre?.FAQ && this.genre.FAQ.length > 0;
    }
  },
  destroyed() {
    SessionStorageService.set(
      'previousRoute',
      this.$store.state.ContextStore.previousNotGenreRoute
    );
  },
  methods: {
    filterChanged(searcher) {
      const builder = SearchPublicationsFactory.searcherToBuilder(searcher);
      builder.setCollectionIncluded(true);
      const newSearcher = builder.build();
      this.customSearcher = newSearcher;
      this.$store.commit('LibraryStore/setGenreSearcher', newSearcher);
    }
  }
};
</script>

<style lang="less"></style>
